import { jsx as _jsx } from "react/jsx-runtime";
import { Notice } from '@tencent/cms-design-component';
import React, { useEffect, useState } from 'react';
import dataFormat from '../utils/data-format';
import ls from '../utils/localStorage';
var NoticeComponent = function(param) {
    var tmp = param.component_id, componentId = tmp === void 0 ? '' : tmp, tmp1 = param.component_object, componentObject = tmp1 === void 0 ? {
    } : tmp1;
    var LS_NOTICE_KEY = 'INTL_NOTICE_TIP';
    var LS_NOTICE_SWITCH_KEY = 'INTL_NOTICE_SWITCH';
    var CONST_ONE = 1;
    var CONST_TWO = 2;
    var properties = JSON.parse(componentObject).properties; // 获取cms的具体配置信息
    var ref = useState(-1), noticeVisible = ref[0], setNoticeVisible = ref[1]; // 公告展示逻辑，默认没取到ls里面值时为-1，展示为1，点击关闭后设为2
    var ref1 = useState(null), noticeSwitch = ref1[0], setNoticeSwitch = ref1[1]; // 公告模式切换
    useEffect(function() {
        var noticeVal = ls.get(LS_NOTICE_KEY);
        var noticeSwitchVal = ls.get(LS_NOTICE_SWITCH_KEY);
        if (!noticeVal) {
            setNoticeVisible(1);
        } else {
            setNoticeVisible(noticeVal);
        }
        setNoticeSwitch(noticeSwitchVal);
    }, []);
    // 返回的配置数据必须是对象，才会进行后续操作
    if (Object.prototype.toString.call(properties) === '[object Object]') {
        // ls异步没取到值时通知不显示
        if (noticeVisible < 0) {
            return null;
        }
        var ref2 = dataFormat.formatNotice(properties), txt = ref2.txt, type = ref2.type, longTimeMode = ref2.longTimeMode;
        // 模式切换时，重置保存的值，让通知显示出来
        if (longTimeMode === noticeSwitch) {
            if (!longTimeMode && noticeVisible === CONST_TWO) {
                //  一次性模式+ls为2时不展示Notice
                return null;
            }
        } else {
            ls.set(LS_NOTICE_KEY, CONST_ONE);
        }
        ls.set(LS_NOTICE_SWITCH_KEY, longTimeMode);
        return(/*#__PURE__*/ _jsx("div", {
            id: componentId,
            children: /*#__PURE__*/ _jsx(Notice, {
                txt: txt,
                type: type,
                onNoticeClick: function() {
                    if (!longTimeMode) {
                        // 一次性模式下点击关闭设置ls
                        ls.set(LS_NOTICE_KEY, CONST_TWO);
                    }
                }
            })
        }));
    }
};
export default NoticeComponent;
